import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from './Sidebar';
import AppNavigation from './AppNavigation';
import STLFinderCard from './STLFinderCard';
import './AISupport.css';

const AISupport: React.FC = () => {
  const { currentUser } = useAuth();
  const { t } = useTranslation('common');
  
  return (
    <div className="app-container">
      <Sidebar currentUser={currentUser} />
      
      <div className={`main-content with-sidebar`}>
        <AppNavigation pageTitle={t('navigation.aiSupport')} />
        <div className="ai-support-centered">
          <div className="centered-card">
            <STLFinderCard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AISupport; 